import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from '../../../utils/utilities.js'

import ValidationIcons from '../../../reusable/ValidationIcons/ValidationIcons';

import { DELIVERY_ICONS_EMAIL_ADDRESSES_ALLOWED } from './../../../../scripts/constants.js';
import api from './../CreateAlertPage.api';
import xhr from '../../../utils/xhr';

export const ALERT_EMAILS_VALIDATION_VALID = 'isValid';
export const ALERT_EMAILS_VALIDATION_INVALID = 'isInvalid';
export const ALERT_EMAILS_VALIDATION_LOADING = 'isLoading';
export const ALERT_EMAILS_ERROR_EMPTY_INPUT = 'emptyInput';
export const ALERT_EMAILS_ERROR_MALFORMED_EMAIL = 'malformedEmail';
export const ALERT_EMAILS_ERROR_UNSUBSCRIBED_USER = 'unsubscribedEmails';
export const ALERT_EMAILS_ERROR_EXCEEDING_ALLOWED_EMAILS = 'exceedsAllowedEmails';

export default class EmailsInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            validatingState:        null,
            unsubscribedEmails:     '',
            emailInputErrorMessage: ''
        };

        this.validateInputField = this.validateInputField.bind(this);
        this.setEmailInputErrorMessage = this.setEmailInputErrorMessage.bind(this);
        this.changeEmailsInputField = this.changeEmailsInputField.bind(this);

    }

    validateInputField() {
        let emailsAreValid = utils.isEmailAddressValid(this.props.data.emails);
        if (emailsAreValid) {
            this.setState({validatingState: ALERT_EMAILS_VALIDATION_LOADING});
            api.validateEmailAddress(this.props.data.emails.split(','))
                .then((response) => {
                    if (response.body && response.body.length === 0) {
                        this.setState({
                            validatingState:        ALERT_EMAILS_VALIDATION_VALID,
                            emailInputErrorMessage: ''
                        });
                        this.props.validateStepTwo(true);
                        this.props.toggleSaveButtonDisabled(true);
                    } else {
                        this.setState({
                            validatingState:        ALERT_EMAILS_VALIDATION_INVALID,
                            emailInputErrorMessage: ALERT_EMAILS_ERROR_UNSUBSCRIBED_USER,
                            unsubscribedEmails:     response.body ? response.body.join(', ') : ''
                        });
                        this.props.validateStepTwo(false);
                        this.props.toggleSaveButtonDisabled(false);
                    }
                })
                .catch((error) => {
                    utils.logError(error, "validateEmailAddress():");
                    xhr.handleAllErrors(error);
                });
        } else {
            this.setState({validatingState: ALERT_EMAILS_VALIDATION_INVALID});
            this.props.validateStepTwo(false);
            this.props.toggleSaveButtonDisabled(emailsAreValid);
            this.setEmailInputErrorMessage();
        }
    }

    setEmailInputErrorMessage() {

        let emails = this.props.data.emails;

        if (this.props.data.emails.length === 0) {
            this.setState({emailInputErrorMessage: ALERT_EMAILS_ERROR_EMPTY_INPUT});
            return;
        }

        let emailAddresses = emails.split(',');
        if (emailAddresses.length > DELIVERY_ICONS_EMAIL_ADDRESSES_ALLOWED) {
            this.setState({emailInputErrorMessage: ALERT_EMAILS_ERROR_EXCEEDING_ALLOWED_EMAILS});
            return;
        }

        let emailAddressesValidity = true;
        this.setState({emailInputErrorMessage: ''});
        for (let i = 0; i < emailAddresses.length; i++) {
            emailAddresses[i] = emailAddresses[i].trim();
            emailAddressesValidity = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){0,10}?$/.test(
                emailAddresses[i]);
            if (!emailAddressesValidity) {
                this.setState({emailInputErrorMessage: ALERT_EMAILS_ERROR_MALFORMED_EMAIL});
                break;
            }
        }

    }

    changeEmailsInputField(event) {
        let inputValue = event.target.value;
        this.props.saveData({'emails': inputValue});

        //while the user types, remove validation icons, and disabled the save button
        if (this.state.validatingState) {
            this.setState({validatingState: null});
        }
        this.props.toggleSaveButtonDisabled(false);
    }

    render() {

        return (
            <div className='create-alert-page__step-two--emails'>
                <div className='email-title'>
                    <FormattedMessage id='Alerts_Create_UIText_steps.step2.sendAlertTo' />:
                    <span className='required-field-star'></span>
                </div>

                <span className='input-container'>
                    <input type="text"
                           disabled={this.state.validatingState === ALERT_EMAILS_VALIDATION_LOADING}
                           className="alert-emails-input"
                           onChange={this.changeEmailsInputField}
                           onBlur={this.validateInputField}
                           value={this.props.data.emails} />

                    <div className='validation-icons'>
                        {
                            this.state.validatingState ?
                                <ValidationIcons renderState={this.state.validatingState} />
                                :
                                null
                        }
                    </div>
                </span>

                <div className='email-error-message'>
                    {
                        this.state.emailInputErrorMessage ?
                            <FormattedMessage id={'Alerts_Create_UIText_error.' + this.state.emailInputErrorMessage}
                                              values={{unsubscribedEmails: this.state.unsubscribedEmails}} />
                            :
                            null
                    }
                </div>

                <div className='email-disclaimer'>
                    <FormattedMessage id='Alerts_Create_UIText_steps.step2.disclaimer'
                                      values={{allowedNumberOfEmails: DELIVERY_ICONS_EMAIL_ADDRESSES_ALLOWED}} />
                </div>
                <div className='gdpr-disclaimer'>
                    <FormattedMessage id='Alerts_Create_UIText_steps.step2.disclaimerGDPR' />
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepTwoComponents/CreateAlert.StepTwo.EmailsInput.jsx